import { Avatar } from "@mantine/core"
import { useGetAuthenticatedUser } from "../../app/-components/use-authenticated-user"
import { ChatIcon } from "./ChatIcon"
import { PersonProfilePictureAvatar } from "../../app/-components/person-profile-picture-avatar"
import { ChatDto } from "@/orval/gen/model"
import { useBatchedSimpleUser } from "@/-dataloaders/simple-users"
import { IconEyeOff } from "@tabler/icons-react"
import { useChatAttachmentApi } from "@/attachment-api/chat-attachment-api"
import { debugLog } from "@/utils/debugLog"

interface Props {
  chat: ChatDto
}

export function ChatAvatar({ chat }: Props) {
  const { data: authenticatedUser } = useGetAuthenticatedUser()
  const cm =
    chat.chatMembers.find((cm) => cm.userId !== authenticatedUser.userId) ??
    chat.chatMembers[0]
  const { data: user } = useBatchedSimpleUser(cm?.userId ?? 0)
  const attachmentApi = useChatAttachmentApi()

  const profileUrl = chat.groupProfilePictureId
    ? attachmentApi.getThumbnailUrl(
        chat.groupProfilePictureId,
        chat.chatId,
        64,
        false
      )
    : undefined

  if (chat.chatType === "Direct") {
    return user ? (
      <PersonProfilePictureAvatar
        personId={user?.personId}
        fallbackName={user?.userName ?? authenticatedUser.userName}
      />
    ) : (
      <PersonProfilePictureAvatar
        personId={authenticatedUser?.personId ?? undefined}
        fallbackName={authenticatedUser?.userName}
      />
    )
  }

  return (
    <Avatar src={profileUrl}>
      {chat.isHidden ? (
        <IconEyeOff size={14} />
      ) : (
        <ChatIcon chatType={chat.chatType} />
      )}
    </Avatar>
  )
}
